import { render } from "./Balance.vue?vue&type=template&id=6feaff65&scoped=true&ts=true&lang=pug"
import script from "./Balance.vue?vue&type=script&lang=ts"
export * from "./Balance.vue?vue&type=script&lang=ts"

import "./Balance.vue?vue&type=style&index=0&id=6feaff65&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6feaff65"]])

export default __exports__